import React from 'react'
import SuspenseLoading from '@components/SuspenseLoading'
import useState from '@hooks/useState'
import useUserId from '@hooks/useUserId'
import saveJWT from '@providers/apollo/saveJWT'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'

import LoggedIn from '../LoggedIn'
import useOnLogin from '../useOnLogin'

const LoginWithCode = dynamic(() => import('./LoginWithCode'), {loading: SuspenseLoading})
const RequestCode = dynamic(() => import('./RequestCode'), {loading: SuspenseLoading})
const Register = dynamic(() => import('./Register'), {loading: SuspenseLoading})

export default function Login(props) {
  const onLogin = useOnLogin()

  const {loading, showRedBorder = false} = props
  const userId = useUserId()
  const [token, setToken] = useState()
  const [email, setEmail] = useState()

  const onSuccess = async session => {
    console.log('Saving new session JWT')
    await saveJWT(session)

    if (onLogin) {
      await onLogin()
    }
  }

  if (!loading && userId) return <LoggedIn />

  if (token) {
    return <LoginWithCode token={token} onSuccess={onSuccess} setToken={setToken} email={email} />
  }

  if (email) {
    return <Register changeEmail={() => setEmail(null)} email={email} onSuccess={onSuccess} />
  }

  return <RequestCode setEmail={setEmail} setToken={setToken} showRedBorder={showRedBorder} />
}

Login.propTypes = {
  onLogin: PropTypes.func,
  loading: PropTypes.bool,
  showRedBorder: PropTypes.bool
}
